import { SegmentModeBar } from '@/components/route-segment-panel/segment-mode-bar';
import { ItineraryLegModel } from '@/lib/models/itinerary/types';
import { getKeyItineraryLocations } from '@/lib/models/itinerary/utils/get-key-itinerary-locations';
import { tv } from '@/utils/styles';

import { JourneyLeg } from '../leg';
import { JourneyLegEvents } from '../leg-events';
import { JourneyLegLocation } from '../leg-location';

export interface JourneyItineraryProps {
  legs: ItineraryLegModel[];
}

const JourneyItinerary = ({ legs }: JourneyItineraryProps) => {
  const keyLocationIds = getKeyItineraryLocations(legs);

  const { base, content, journeyBar, journeyLeg } = styles();

  return (
    <div className={base()}>
      {keyLocationIds.map((locationId, index) => {
        const thisLeg = legs[index] || null;
        return (
          <div key={`location_${index}`} className={content()}>
            <JourneyLegLocation locationId={locationId} />
            {thisLeg && (
              <>
                <div className={journeyBar()}>
                  <SegmentModeBar mode={thisLeg.mode} showEndMarker />
                </div>
                <JourneyLeg leg={thisLeg} className={journeyLeg()} />
                <JourneyLegEvents events={thisLeg.stopIds} mode={thisLeg.mode} />
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'flex flex-col gap-6 rounded-lg border border-grey-200 bg-white p-4 md:p-8',
    content: 'relative pl-14',
    journeyBar: 'absolute -bottom-[68px] left-4 top-0.5 flex',
    journeyLeg: 'relative z-2 -ml-14 mt-6',
  },
});

export { JourneyItinerary };
